import { API, authClient } from "../index";

export const getObraStatus = (accessToken) => {
  return authClient(accessToken).get(`${API}/obra-status`);
};
